import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/users/', { params: params });
  },
  createData() {
    return Backend.get('/users/create');
  },
  editData(userId) {
    return Backend.get(`/users/${userId}/edit`);
  },
  create(createData) {
    return Backend.post('/users/', createData);
  },
  update(id, updateData) {
    return Backend.put(`/users/${id}`, updateData);
  },
  updateActive(id, isActive) {
    return Backend.put(`/users/${id}/change-active`, { is_active: isActive });
  },
  profileUpdate(id, updateData) {
    return Backend.put(`/users/${id}/profile`, updateData);
  }
};
